export default {
  link: styles => ({
    display: 'flex',
    cursor: 'pointer',
    width: 'fit-content',
    ...styles
  })
}
